import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {

    transform(collection: Array<any>, property: string = 'reportCategory'): Array<any> {
        if (!collection) {
            return null;
        }

        const c = collection.reduce((groups, item) => {
            let propertyName = item[property];

            const group = (groups[propertyName.name] || []);
            group.push(item);
            groups[propertyName.name] = group;
            return groups;
        }, {});

        const res = [];
        for (const key in c) {
            if (c.hasOwnProperty(key)) {
                res.push({
                    groupBy: key,
                    data: c[key]
                });
            }
        }

        return res;

    }

}
